import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 771135B5-F856-4AAE-9FD1-8F728964DE2F
 * name distribute-horizontal-right
 * version: 4.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/distribute-horizontal-right.svg
 * tags
 */
export const DistributeHorizontalRightIcon = createSvgIcon(<><path d="M3 17V7H8V2H10V22H8V17H3M19 22H21V2H19V5H14V19H19V22Z" /></>, 'DistributeHorizontalRightIcon');
export default DistributeHorizontalRightIcon